import { render, staticRenderFns } from "./licence.vue?vue&type=template&id=312ae1f0&scoped=true&"
import script from "./licence.vue?vue&type=script&lang=js&"
export * from "./licence.vue?vue&type=script&lang=js&"
import style0 from "./licence.vue?vue&type=style&index=0&id=312ae1f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312ae1f0",
  null
  
)

export default component.exports